import _ from 'underscore';
import React, { useCallback, useEffect } from 'react';

export const useInfiniteScroll = (scrollViewRef: React.RefObject<HTMLElement>, onReachEnd: () => void) => {
  const onScroll = useCallback((event: Event) => {
    const target = event.target as HTMLElement;

    if (target.scrollHeight - target.scrollTop <= target.clientHeight) {
      onReachEnd?.();
    }
  }, [onReachEnd]);

  useEffect(() => {
    if (!onReachEnd) {
      return _.noop;
    }

    const currentElement = scrollViewRef.current;

    if (!currentElement) {
      return _.noop;
    }

    currentElement.addEventListener('scroll', onScroll);

    return () => {
      currentElement.removeEventListener('scroll', onScroll);
    };
  }, [scrollViewRef, onScroll, onReachEnd]);
};
